import styled from '@tanium/react-emotion';
import { css } from '@tanium/style-system';
import { ThemeFontWeights } from '@tanium/theme-data';
import { TitleText } from './themeDefinitions';

export const FormTitle = styled('h4')(
  css({
    margin: 0,
    fontSize: '24px',
    fontWeight: ThemeFontWeights.Bold,
    lineHeight: '26px',
    color: TitleText,
  }),
);
